<template>
    <div
        class="relative flex w-full px-4 py-6 mb-4 bg-white border border-gray-200 rounded shadow-sm"
    >
        <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
            <div class="max-w-4xl mx-auto ">
                <h2
                    class="text-xl font-extrabold leading-9 text-blue-600 sm:text-xl sm:leading-10"
                    :class="titleClass"
                >
                    {{ title }}
                    <svg
                        v-if="info"
                        @click="$emit('modal')"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        class="inline w-6 h-6 text-4xl text-gray-700 fill-current information-circle"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                </h2>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String
        },
        titleClass: {
            type: String,
            default: "text-left"
        },
        info: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style></style>
